import { createSlice } from "@reduxjs/toolkit";

export const removeListHandleSlice = createSlice({
  name: "removeListHandle",
  initialState: {
    value: [],
  },
  reducers: {
    addRemoveList: (state, payload) => {
      state.value.push(payload.payload as never);
    },
    setRemoveList: (state, payload) => {
      state.value = payload.payload;
    },
    clearRemoveList: (state) => {
      state.value = [];
    },
  },
});

// 为每个 case reducer 函数生成 Action creators
export const { addRemoveList, setRemoveList, clearRemoveList } =
  removeListHandleSlice.actions;

export default removeListHandleSlice.reducer;
